/* eslint-disable jsx-a11y/anchor-is-valid */
import {FC} from 'react'
import {setDefaultOptions} from 'esri-loader'
import Map from '../../../../../../_metronic/partials/widgets/map/map'

const EnterprisesMap: FC = () => {
  setDefaultOptions({css: true})
  return <Map />
}
export {EnterprisesMap}
